import { render, staticRenderFns } from "./GlobalSuccess.vue?vue&type=template&id=38db7801&scoped=true&"
import script from "./GlobalSuccess.vue?vue&type=script&lang=js&"
export * from "./GlobalSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db7801",
  null
  
)

export default component.exports